namespace Core {
    angular
        .module('core')
        .config(($provide, $httpProvider) => {

            $provide.factory('domainIdHeaderInterceptor', () => ({
                request(config) {
                    if(config && config.headers) {
                        config.headers['x-domain-id'] = TRPCONFIG.Domain.DomainId;
                        config.headers['x-trp-applicationtype'] = 1;
                    }
                    return config;
                }
            }));

            if ($httpProvider.interceptors.indexOf('domainIdHeaderInterceptor') < 0) {
                $httpProvider.interceptors.push('domainIdHeaderInterceptor');
            }
        });
}
